import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import {Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import pathObj from "../services/Config";

const GuestPaymentPage = () => {
  const { search } = useLocation();
  const [errorMessage, setErrorMessage] = useState(""); // <-- Add this
  const orderId = search ? search.substring(1) : null;

  useEffect(() => {
    if (!orderId) {
      setErrorMessage("OrderId missing in URL");
      return;
    }

    const fetchPaymentDetails = async () => {
      try {
        const res = await axios.post(
          `${pathObj.baseURL}${pathObj.getInstantPayDetails}`,
          { order_id: orderId },
          { headers: { "Content-Type": "application/json" } }
        );

        if (res?.data?.success) {
          const formData = res.data.data;

        // Sandbox vs Production action
        const actionUrl = formData.testMode === "100"
          ? "https://secure-test.worldpay.com/wcc/purchase" // Test mode
          : "https://secure.worldpay.com/wcc/purchase";     // Live mode

        const form = document.createElement("form");
        form.action = actionUrl;
        form.method = "POST";

        Object.keys(formData).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = formData[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        } else {
          setErrorMessage(res.data.message || "Payment initialization failed.");
        }
      } catch (err) {
        // If API returns error response (like 400), show its message
        if (err.response && err.response.data && err.response.data.message) {
          setErrorMessage(err.response.data.message);
        } else {
          setErrorMessage("Something went wrong!");
        }
      }
    };

    fetchPaymentDetails();
  }, [orderId]);

  return (
    <div style={{ minHeight: 200, alignItems: "center", justifyContent: "center" }}>
      {errorMessage ? (
        // <div style={{ color: "red", fontWeight: "bold", fontSize: "1.2em" }}>{errorMessage}</div>
        <div className="thankYou_bx pad_t80 pad_b75">
            <div className='container'>
                <div className="d-flex justify-content-center">
                    <div className="card col-xl-5 col-lg-8 col-md-10 col-sm-10 bg-white shadow-lg p-5">
                        <div className="mb-4 text-center" style={{ color: 'green' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="text-success" width="75" height="75"
                                fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path
                                    d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                            </svg>
                        </div>
                        <div className="text-center">
                            <h1>Payment Already Paid</h1>
                            <p className='mb-4 fs-6'>{errorMessage}</p>
                            {/* <Link to="/login" className="button2"> Try Again </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      ) : (
        // <div>Redirecting to payment...</div>
        <div className="thankYou_bx pad_t80 pad_b75">
            <div className='container'>
                <div className="d-flex justify-content-center">
                    <div className="card col-xl-5 col-lg-8 col-md-10 col-sm-10 bg-white shadow-lg p-5">
                        {/* <div className="mb-4 text-center" style={{ color: 'red' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75"
                                fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </div> */}
                        <div className="text-center">
                            <h1>Redirecting to payment...</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      )}
    </div>
  );
};

export default GuestPaymentPage;